if (!customElements.get('outfit-complete')) {
  customElements.define('outfit-complete', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-oc-color-picker]')) this.switchColor(event.target);
        if (event.target.matches('[data-oc-size]')) this.select(event.target);
      });
      this.prepare();
      if (this.dataset.url && !this.dataset.loaded) {
        this.dataset.loaded = 'true';
        fetch(this.dataset.url)
          .then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
          .then(html => {
            const list = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-oc-list]');
            if (!list?.querySelector('.outfit-complete__row')) return;
            this.querySelector('[data-oc-list]').innerHTML = list.innerHTML;
            this.prepare();
            this.hidden = false;
          })
          .catch(() => {});
      }
    }
    prepare() {
      const max = parseInt(this.dataset.max, 10) || 4;
      this.querySelectorAll('.outfit-complete__row').forEach((row, index) => {
        if (index >= max) { row.remove(); return; }
        const select = row.querySelector('.outfit-complete__sizes:not([hidden]) select');
        if (this.classList.contains('oc--no-sizes') && select && !select.value) {
          select.value = select.querySelector('option[data-default]')?.value || '';
        }
        if (select) this.select(select);
      });
    }
    switchColor(picker) {
      const form = picker.closest('form');
      const color = picker.selectedOptions[0];
      const image = form.querySelector('.outfit-complete__media img');
      if (image && color.dataset.img) { image.removeAttribute('srcset'); image.src = color.dataset.img; }
      this.updateLinks(form, color.dataset.href);
      this.updatePrice(form, color);
      let active = null;
      form.querySelectorAll('.outfit-complete__sizes').forEach(group => {
        group.hidden = group.dataset.ocColor !== picker.value;
        const select = group.querySelector('select');
        select.value = '';
        if (!group.hidden) active = select;
      });
      if (active) {
        if (active.options.length === 2 || this.classList.contains('oc--no-sizes')) {
          active.value = active.querySelector('option[data-default]')?.value || '';
        }
        this.select(active);
      }
      const error = form.querySelector('.product-form__error-message-wrapper');
      if (error) error.hidden = true;
    }
    select(picker) {
      const form = picker.closest('form');
      const option = picker.selectedOptions[0];
      const available = Boolean(option?.value && !option.disabled);
      const input = form.querySelector('input[name="id"]');
      input.value = available ? option.value : '';
      const button = form.querySelector('button[name="add"]');
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      button.querySelector('span').textContent = available ? button.dataset.addLabel : 'Kies eerst een maat';
      if (available) {
        this.updatePrice(form, option);
        this.updateLinks(form, option.dataset.href);
      }
    }
    updateLinks(form, href) {
      if (!href) return;
      form.querySelectorAll('.outfit-complete__media, .outfit-complete__title').forEach(link => { link.href = href; });
    }
    updatePrice(form, option) {
      const price = form.querySelector('[data-oc-price]');
      price.querySelector('[data-oc-now]').textContent = option.dataset.price || '';
      price.querySelector('[data-oc-was]').textContent = option.dataset.compare || '';
      price.classList.toggle('outfit-complete__price--regular', !option.dataset.compare);
    }
  });
}
